import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Autocomplete from '@mui/material/Autocomplete';

import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { getActiveUsers } from "../../settings/api/actions";
import { getWorkOrderStatusTypes } from "../../apl/api/actions";
import { createWorkOrder, getWorkOrders, getWorkOrdersByUnit } from "../api/actions";
import { formatWorkOrderAddress } from "../utils/formatWorkOrderAddress";
import Typography from "@mui/material/Typography";

function CreateWorkOrder(props) {
  const [users, setUsers] = useState(props.setting.activeUsers.items || [{ id: "", label: "" }]);
  const [properties, setProperties] = useState(props.properties?.data?.propertiesList?.items || [{ id: "", label: "" }]);
  const [status, setStatus] = useState(
    props.apl?.genericTypes?.workOrderStatus?.data || [{ id: "", label: "" }]
  );
  const [user, setUser] = useState(props.user.details || {});
  const [units, setUnits] = useState([{ id: "", label: "" }])
  let optionsUnits = [];
  const optionsProperties = properties.map(property => {
    return { label: `${property.name}`, id: property.id }
  })

  const options = users.map(user => {
    return { label: `${user.firstName} ${user.lastName}`, id: user.id }
  })

  const workOrderStatusOptions = status.map(status => {
    return { label: `${status.description}`, id: status.id }
  })
  const newOption = workOrderStatusOptions.find(ws => {
    return ws.label == "New"
  })
  const [add, setAdd] = useState(props.show);
  const [item, setItem] = useState(props.item);
  const [state, setState] = useState({
    workOrderTitle: "",
    assignedTo: "",
    workOrderStatusId: newOption?.id || "",
    dueDate: "",
    unitUuid: "",
    workOrderNotes: "",
  });
  const [error, setError] = useState(false);

  const handleSave = async () => {
    let currentState = state;
    if (props.existingUnit) {
      currentState.unitUuid = props.existingUnit.unit.uuid;
    }
    const body = {
      assignedTo: String(currentState.assignedTo),
      dueDate: currentState.dueDate,
      unitUuid: currentState.unitUuid,
      workOrderStatusId: currentState.workOrderStatusId,
      workOrderTitle: currentState.workOrderTitle,
      workOrderNotes: currentState.workOrderNotes || ""
    };
    if (props.complaintId) {
      body.complaintId = props.complaintId;
    }
    const isEmpty = Object.values(body).some(x => x === null || x === '');

    if (!isEmpty) {
      props.createWorkOrder(body).then(() => {
        if (!props.existingUnit) {
          props.getWorkOrders()
        }
        else {
          props.getWorkOrdersByUnit(props.existingUnit.unit.id);
        }
        if (props.onComplaintWorkOrderCreated) {
          props.onComplaintWorkOrderCreated();
        }
      })
      setError(false);
      setAdd(false);
      if (props.onChange) {
        props.onChange(null);
      }
    }
    else {
      setError(true);
    }
  };

  const propertyChange = async (event, value) => {
    setState({ ...state, propertyId: value?.id || "" })
    try {
      if (value?.id) {

        let response = await axios.get(`/property/${value.id}/unit`);

        if (response.status = 200) {
          let units = response.data;
          optionsUnits = units.map(unit => {
            return { label: formatWorkOrderAddress(unit) || "Unit", id: unit.uuid };
          })
          setUnits(optionsUnits)
        }
        else {
          setState({ ...state, unitUuid: "" })
          setUnits([{ id: "", label: "" }])

        }
      }
      else {
        setUnits([{ id: "", label: "" }])
      }
    }
    catch (e) {

    }
  }

  const handleCancel = () => {
    setAdd(false);
    if (props.onChange) {
      props.onChange(null);
    }
  };

  const handleClose = () => {
    setAdd(false);
    if (props.onChange) {
      props.onChange(null);
    }
  }

  const handleChange = (evt) => {
    let value = evt.target.value;
    if (evt.target.name == "isActive") value = evt.target.checked;

    setState({
      ...state,
      [evt.target.name]: value,
    });
  };


  useEffect(() => {
    if (props.setting.activeUsers.items.length <= 0) {
      props.getActiveUsers();
    }
  }, [])

  useEffect(() => {
    const woStatusData = props.apl?.genericTypes?.workOrderStatus?.data;
    if (
      props.show &&
      (!woStatusData || woStatusData.length === 0)
    ) {
      props.getWorkOrderStatusTypes();
    }
  }, [props.show]);

  // Update local state when props change (data loads async)
  useEffect(() => {
    if (props.setting.activeUsers.items && props.setting.activeUsers.items.length > 0) {
      setUsers(props.setting.activeUsers.items);
    }
  }, [props.setting.activeUsers.items]);

  useEffect(() => {
    const data = props.apl?.genericTypes?.workOrderStatus?.data;
    if (!data || data.length === 0) {
      return;
    }
    setStatus(data);
    setState((prev) => {
      if (prev.workOrderStatusId) {
        return prev;
      }
      const newRecord = data.find((ws) => ws.description === "New");
      if (!newRecord) {
        return prev;
      }
      return { ...prev, workOrderStatusId: newRecord.id };
    });
  }, [props.apl?.genericTypes?.workOrderStatus?.data]);

  useEffect(() => {
    setAdd(props.show);
  }, [props.show]);

  useEffect(() => {
    if (props.show && props.prefilledWorkOrderTitle) {
      setState((prev) => ({
        ...prev,
        workOrderTitle: props.prefilledWorkOrderTitle,
      }));
    }
  }, [props.show]);

  return (
    <div>
      <Dialog
        open={add}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="md"
        minHeight='80vh'
        max
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          <>{!props.new ? "Update Work Order" : "New Work Order"}</>
          {props.existingUnit && (
            <Typography>
              {props.existingUnit.property.name}
              {formatWorkOrderAddress(props.existingUnit.unit)
                ? ` - ${formatWorkOrderAddress(props.existingUnit.unit)}`
                : ""}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="workOrderTitle"
            name="workOrderTitle"
            value={state.workOrderTitle}
            label="Work Order Title"
            type=""
            fullWidth
            error={error && state.workOrderTitle == ""}
            onChange={handleChange}
          />
          <div>
            <Autocomplete
              disablePortal
              isOptionEqualToValue={(option, value) => option.id === value.id}
              id="assignedTo"
              name="assignedTo"
              defaultValue={options.find(v => v.id == state.assignedTo)}
              onChange={(event, value) => setState({ ...state, assignedTo: value?.id || "" })}
              options={options}
              error={error}
              sx={{ my: 2 }}
              renderInput={(params) => <TextField {...params} label="Assigned To" error={error && state.assignedTo == ""} />}
            />
            <Autocomplete
              disablePortal
              required
              isOptionEqualToValue={(option, value) => option.id === value.id}
              id="workOrderStatusId"
              name="workOrderStatusId"
              error={error}
              defaultValue={workOrderStatusOptions.find(v => v.label == "New")}
              onChange={(event, value) => setState({ ...state, workOrderStatusId: value?.id || "" })}
              options={workOrderStatusOptions}
              sx={{ my: 2 }}
              renderInput={(params) => <TextField error={error && state.workOrderStatusId == ""} {...params} label="Status" />}
            />
            {!props.existingUnit &&
              <>
                <Autocomplete
                  disablePortal
                  required
                  error={error}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  id="propertyId"
                  name="propertyId"
                  onChange={propertyChange}
                  options={optionsProperties}
                  sx={{ my: 2 }}
                  renderInput={(params) => <TextField error={error && state.propertyId == ""} {...params} label="Property" />}
                />
                <Autocomplete
                  disablePortal
                  required
                  error={error}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  id="unitUuid"
                  name="unitUuid"
                  onChange={(event, value) => setState({ ...state, unitUuid: value?.id || "" })}
                  options={units}
                  sx={{ my: 2 }}
                  renderInput={(params) => <TextField error={error && state.unitUuid == ""} {...params} label="Unit" />}
                />
              </>
            }
          </div>
          <TextField
            id="dueDate"
            label="Due Date"
            type="date"
            error={error && state.dueDate == ""}
            name="dueDate"
            sx={{ my: 2, width: '100%' }}
            slotProps={{
              inputLabel: { shrink: true }
            }}
            onChange={handleChange}
          />
          <TextField
            id="workOrderNotes"
            label="Work Order Notes"
            name="workOrderNotes"
            multiline
            rows={4}
            required
            value={state.workOrderNotes}
            sx={{ my: 2, width: '100%' }}
            placeholder="Enter any notes or additional information about this work order..."
            error={error && state.workOrderNotes === ""}
            helperText={
              error && state.workOrderNotes === ""
                ? "Notes are required before you can save."
                : "Required — include details for this work order."
            }
            slotProps={{
              inputLabel: { shrink: true },
            }}
            onChange={handleChange}
          />
          <DialogActions>
            <Button onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} color="secondary">
              Save
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
}
CreateWorkOrder.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  existingUnit: PropTypes.object,
  billing: PropTypes.object,
  properties: PropTypes.object.isRequired,
  getActiveUsers: PropTypes.func.isRequired,
  createWorkOrder: PropTypes.func.isRequired,
  getWorkOrdersByUnit: PropTypes.func.isRequired,
  getWorkOrders: PropTypes.func,
  getWorkOrderStatusTypes: PropTypes.func.isRequired,
  complaintId: PropTypes.number,
  prefilledWorkOrderTitle: PropTypes.string,
  onComplaintWorkOrderCreated: PropTypes.func,
};

// Component State
function CreateWorkOrderState(state) {
  return {
    setting: state.setting,
    apl: state.apl,
    user: state.user,
    properties: state.properties,
    billing: state.billing,
  };
}

export default connect(CreateWorkOrderState, {
  getActiveUsers,
  createWorkOrder,
  getWorkOrders,
  getWorkOrdersByUnit,
  getWorkOrderStatusTypes,
})(
  CreateWorkOrder
);
